const { registerBlockType } = wp.blocks;
const { useBlockProps } = wp.blockEditor;

import metadata from './block.json';

//various componets and functions brought in for use
const { useState, useEffect } = wp.element;

function test() {
}


const Edit = ({ attributes, setAttributes }) => {
	
	useEffect(() => {	
		setAttributes({test:'test'});
	}, []);
	
	let [local, setLocal] = useState({}),
	main = <select onChange={ (event)=>{setLocal({ main:event.target.value})} }>
	  <option value="oasisId">oasisId</option>
	  <option value="recordType">recordType</option>
	  <option value="coreFieldsComp">coreFieldsComp</option>
	  <option value="liteCoreFieldsComp">liteCoreFieldsComp</option>
	  <option value="buildingsCoreFieldsComp">buildingsCoreFieldsComp</option>
	  <option value="reportsInLibrary">reportsInLibrary</option>
	  <option value="deleted">deleted</option>
	  <option value="public">public</option>
	  <option value="oasisProjDetails">oasisProjDetails</option>
	  <option value="oasisReviewersHasOasisList">oasisReviewersHasOasisList</option>
	</select>,
	oasisReviewers = <select>
	  <option value="reviewStatus">reviewStatus</option>
	  <option value="name">name</option>
	  <option value="level">level</option>
	  <option value="reviewByDate">reviewByDate</option>
	</select>,
	oasisProjDetails = <select onChange = { (event)=>{setLocal({...local, details:event.target.value})} }>
	  <option value="archiveExists">archiveExists</option>
	  <option value="biblioExists">biblioExists</option>
	  <option value="c14DateTaken">c14DateTaken</option>
	  <option value="descMethod">descMethod</option>
	  <option value="descOutcome">descOutcome</option>
	  <option value="edate">edate</option>
	  <option value="entryDate">entryDate</option>
	  <option value="envSampling">envSampling</option>
	  <option value="futrWork">futrWork</option>
	  <option value="keywordsExists">keywordsExists</option>
	  <option value="prevWork">prevWork</option>
	  <option value="projName">projName</option>
	  <option value="sdate">sdate</option>
	  <option value="version">version</option>
	  <option value="websiteUrl">websiteUrl</option>
	  <option value="oasisProjPeopleList">oasisProjPeopleList</option>
	</select>,
	operators = <select>
	  <option value="=">{'='}</option>
	  <option value=">=">{'>='}</option>
	  <option value="<">{'<'}</option>
	  <option value="<=">{'<='}</option>
	</select>,
	oasisProjPeopleList = <select>
	  <option value="forename">forename</option>
	  <option value="surname">surname</option>
	  <option value="organisation">organisation</option>
	  <option value="role">role</option>
	  <option value="funderType">funderType</option>
	</select>,
	presentation = [main],
	[more, setMore] = useState([]);
	
	if (local.main !== undefined && local.main == 'oasisProjDetails' ) {
		presentation.push(oasisProjDetails);
	}
	
	if (local.main !== undefined && local.main == 'oasisReviewersHasOasisList' ) {
		presentation.push(oasisReviewers);
	}
	
	if (local.details !== undefined && local.details == 'oasisProjPeopleList' ) {
		presentation.push(oasisProjPeopleList);
	}
	
	presentation.push(operators);
	presentation.push(<input type="text"/>);
	presentation.push(<br/>);
	
	function add () {
		setMore([...more, presentation]);
	}
	
	return <p { ...useBlockProps()}>
		{presentation}
		{more}		
		<button onClick={add}>{'+'}</button>
	</p>;
};
const save = ({ attributes }) => {
	return <p { ...useBlockProps.save() }>{attributes.test}</p>;
}

registerBlockType( "rf-research-framework/oasis-stats", {
    edit: Edit,
    save,
} );